import { VoiceModel } from '../types'

/**
 * Returns the default title for a merged voice model
 * @param voiceModels list of voice models that are being merged
 * @param rawAlphas list of alpha values that represent the percentage of each model in the output model
 */
export const getDefaultModelMergeTitle = (
  voiceModels: Pick<VoiceModel, 'title'>[],
  rawAlphas: number[]
): string => {
  const alphaTotal = rawAlphas.reduce((acc, alpha) => acc! + alpha!, 0) || 0
  const alphas = [...rawAlphas, 1 - alphaTotal]

  let title = ''
  voiceModels.forEach((model, index) => {
    const percentFormatted = Math.round(alphas[index] * 100)
    title += `${percentFormatted}% ${model.title}`
    if (index < voiceModels.length - 1) {
      title += ' + '
    }
  })

  // max 255 characters, truncate if necessary
  return title.slice(0, 255)
}
